import { call, put, takeLatest } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { fetchApiKeys, fetchApiKeyTypes } from 'api/ApiKeyApi';
import { addNegativeToast } from 'modules/toastContainer';
import { fetchApiKeysResponse, fetchApiKeyTypesResponse, setApiKeyErrors } from './actions';
import * as t from './actionTypes';
import { API_KEYS_ERRORS, API_KEY_TYPE_VALUE_ORDER } from './constants';
import { ApiKeyTypeFormatted, ApiKeyTypeRaw } from './types';

const suffix = `If the problem persists, contact customer support.`;
const createMessage = (msg: string) => `${msg} ${suffix}`;

const formatApiKeyTypes = (types: {
  [keyTypeName: string]: ApiKeyTypeRaw;
}): ApiKeyTypeFormatted[] => {
  // explicit sort order defined in constants
  const sortedValues = Object.values(types).sort(
    (a, b) => API_KEY_TYPE_VALUE_ORDER.indexOf(a.value) - API_KEY_TYPE_VALUE_ORDER.indexOf(b.value),
  );
  const formattedKeyTypes = sortedValues.map((key) => ({
    ...key, // keep original object properties { description, label, type, value }
    dataTest: `option-${key.value}`,
    disabled: false,
  }));

  return formattedKeyTypes;
};

export function* fetchApiKeyTypesSaga(): any {
  try {
    const resp = yield call(fetchApiKeyTypes);
    const sortedResponse = yield call(formatApiKeyTypes, resp);
    yield put(fetchApiKeyTypesResponse({ payload: sortedResponse || [] }));
  } catch (err) {
    yield put(setApiKeyErrors({ errors: [API_KEYS_ERRORS.KEYTYPE] }));
  }
}

export function* fetchApiKeysSaga(): any {
  try {
    const resp = yield call(fetchApiKeys);
    yield put(fetchApiKeysResponse({ payload: resp.data?.apiKeys || [] }));
  } catch {
    yield put(setApiKeyErrors({ errors: [API_KEYS_ERRORS.FETCH] }));
    yield put(addNegativeToast(createMessage('Unable to retrieve API keys.')));
  }
}

addToRootSaga([
  takeLatest([t.FETCH_API_KEY_TYPES_REQUEST], fetchApiKeyTypesSaga),
  takeLatest([t.FETCH_API_KEYS_REQUEST], fetchApiKeysSaga),
]);
